import request from "../utils/request";
import { endpoint } from "../utils/config";

export async function getUsers(data) {
  const url = `${endpoint}/users`;
  return await request({
    url,
    method: "get",
    data,
  });
}
export async function getDirectors(data) {
  const url = `${endpoint}/users/account-directors`;
  return await request({
    url,
    method: "get",
    data,
  });
}
export async function getCompanies(data) {
  const url = `${endpoint}/tenants`;
  return await request({
    url,
    method: "get",
    data,
  });
}

export async function getDepartments(data) {
  const url = `${endpoint}/departments`;
  return await request({
    url,
    method: "get",
    data,
  });
}

export async function postUser(data) {
  const url = `${endpoint}/users/signup`;
  return await request({ url, method: "POST", data });
}

export async function postDirector(data) {
  const url = `${endpoint}/users/account-director`;
  return await request({ url, method: "POST", data });
}

export async function postCompany(data) {
  const url = `${endpoint}/tenants/`;
  return await request({ url, method: "POST", data });
}
export async function postDepartment(data) {
  const url = `${endpoint}/departments/`;
  return await request({ url, method: "POST", data });
}

export async function getUserDetails(data) {
  const url = `${endpoint}/parcels/owners/${data.userId}/details`;
  return await request({
    url,
    method: "get",
  });
}

export async function deleteUser(id) {
  const url = `${endpoint}/users/${id}`;
  return await request({
    url,
    method: "delete",
  });
}

export async function deleteDirector(id) {
  const url = `${endpoint}/users/${id}`;
  return await request({
    url,
    method: "delete",
  });
}

export async function deleteCompany(id) {
  const url = `${endpoint}/tenants/${id}`;
  return await request({
    url,
    method: "delete",
  });
}

export async function putResetPassword(email) {
  const url = `${endpoint}/users/recoverPassword/${email}`;
  return await request({
    url,
    method: "put",
  });
}

export async function putEditUser({data, id}){
  const url = `${endpoint}/users/${id}`
  return await request({
    url,
    method: "put",
    data,
  });
}
export async function putEditCompany({data, id}){
  const url = `${endpoint}/tenants/${id}`
  return await request({
    url,
    method: "put",
    data,
  });
}